
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b3e3f0478c8a85835105bdc834bc5878.jpg"
          alt="Business Recovery"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-slate-900/75"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-serif font-bold text-white uppercase tracking-wide mb-6">
          Is Your Business in Distress?
        </h2>
        <p className="text-xl text-gray-200 mb-12 leading-relaxed max-w-2xl mx-auto">
          Don't wait until it's too late. JBS Consulting provides confidential, empathetic, and affordable turnaround solutions. Let's talk about your options today.
        </p>
        <Link to="/contact">
          <button className="inline-flex items-center gap-4 px-10 py-5 bg-orange-500 text-white font-bold rounded-full hover:bg-orange-600 transition-all hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
              <i className="ri-phone-line text-xl text-orange-500"></i>
            </div>
            <span className="uppercase tracking-wide">Get a Free Confidential Assessment</span>
            <i className="ri-arrow-right-up-line text-2xl"></i>
          </button>
        </Link>
      </div>
    </section>
  );
}
